import { TextFieldProps } from '@mui/material';
import { Control, Controller, Path } from 'react-hook-form';

import { TextField } from './TextField';

interface IProps<T> {
  control: Control<T>;
  name: Path<T>;
  label?: string;
}

export function ControllerTextField<T>({
  control,
  label,
  name,
  ...inputProps
}: IProps<T> & TextFieldProps) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          error={Boolean(error)}
          helperText={error?.message}
          label={label}
          margin={inputProps.margin || 'none'}
          type={inputProps.type || 'text'}
          {...inputProps}
        />
      )}
    />
  );
}
